import {useState} from "react";
import {useResizeListener} from "../../../../listeners/SystemResizeListener";
import {isNullOrUndefined} from "../../../../services/Validator";
import ExerciserCorrectionScreen from "../../../../screens/courses/exerciser/ExerciserCorrectionScreen";
import FlashResultsQuestionItemLayout from "../../../layouts/courses/flash/FlashResultsQuestionItemLayout";
import FlashResultsQuestionIndex from "../../../others/courses/flash/FlashResultsQuestionIndex";
import SystemHorizontalStarDivider from "../../../dividers/courses/flash/SystemHorizontalStarDivider";
import FlashResultsQuestionItemChevronIcon from "../../../icons/courses/flash/FlashResultsQuestionItemChevronIcon";
import CoursesResultsQuestionStatementText from "../../../texts/courses/CoursesResultsQuestionStatementText";

export default function ExerciserResultsQuestionItem({index, total, question, levelA}) {
    // Used in ResultsQuestionsList to display one single
    // question element that leads to correction

    // PROPERTIES
    const [isCorrectionModalOpen, setIsCorrectionModalOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsCorrectionModalOpen(false))

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className="w-full flex flex-col space-y-6">
            {/** CORRECTION MODAL */}
            <ExerciserCorrectionScreen open={isCorrectionModalOpen}
                                       handleClose={() => setIsCorrectionModalOpen(false)}
                                       question={question}
                                       levelA={levelA} />
            {/** CORE */}
            <FlashResultsQuestionItemLayout setIsHovered={setIsHovered}
                                            openModal={() => openModal()}>
                <FlashResultsQuestionIndex number={index + 1}
                                           correctness={question?.userSubmission.isCorrect} />
                <CoursesResultsQuestionStatementText statement={question?.question}
                                                     isHovered={isHovered} />
                <FlashResultsQuestionItemChevronIcon isHovered={isHovered} />
            </FlashResultsQuestionItemLayout>
            {/** BOTTOM DIVIDER IF NECESSARY */}
            {index === (total - 1) ? null : <SystemHorizontalStarDivider />}
        </div>
    );

    // METHODS
    // ---- Open modal
    function openModal() {
        // NAV : Open modal
        setIsCorrectionModalOpen(true)
    }

}